import { Avatar, Dialog, DialogContent, DialogTitle, IconButton } from '@mui/material'
import CloseIcon from '@mui/icons-material/Close';
import React from 'react'
import Assefaz from '../Authentications/Assefaz/Assefaz';
import Arlequim from '../Authentications/Arlequim/Arlequim';
import Unifecaf from '../Authentications/Unifecaf/Unifecaf';
import ClubeDoAluno from '../Authentications/ClubeDoAluno/ClubeDoAluno';
import Promove from '../Authentications/Promove/Promove';
import { Title } from './Styled';


const Default = ({slug, incentiveId, handleClose, open, logo, name, onSuccess}) => {

  const Authentication = () =>

    slug === "arlequim" ? <Arlequim /> :
    slug === "assefaz" ? <Assefaz /> :
    slug === "clube-do-aluno" ? <ClubeDoAluno incentiveId={incentiveId} handleClose={handleClose} onSuccess={onSuccess} /> :
    slug === "unifecaf" ? <Unifecaf/> :
    slug === "clube-de-vantagens" ? <ClubeDoAluno incentiveId={incentiveId} handleClose={handleClose} onSuccess={onSuccess} />:
    slug === "promove" ? <Promove incentiveId={incentiveId} handleClose={handleClose} onSuccess={onSuccess} /> :
    null;


  // const paragraphs = longDescription.includes('/') ? longDescription.split('/'): longDescription;
  
  return (
      <Dialog
        onClose={handleClose}
        aria-labelledby="customized-dialog-title"
        open={open}
        fullWidth
        maxWidth="xs"
        sx={{
          '& .MuiDialog-paper': {
            width: { xs: 'calc(100% - 32px)', sm: 400 },
            maxWidth: '400px',
            margin: { xs: '16px' },
          },
        }}
      >

        <DialogTitle
        sx={{
          m: 0,
          p: 2,
          display: 'flex',
          justifyContent: 'space-between',
          gap: '10px'
        }} id="customized-dialog-title">
          <Avatar alt="Remy Sharp" src={logo}/>
          <Title>
            {name}
          </Title>

          <IconButton
          aria-label="close"
          onClick={handleClose}
          sx={{
            color: (theme) => theme.palette.grey[500],
          }}
        >
          <CloseIcon />
        </IconButton>
        </DialogTitle>
        <DialogContent
        sx={{
          borderBottom: '0',
          maxHeight: '80vh',
          overflowY: 'auto',
        }}
        dividers>
          {Authentication()}
        </DialogContent>
      </Dialog>
  )
}

export default Default